import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useTareas } from '../../context/TareasContext';
import {
  AjustesAvisosTareas, guardarAjustesTareas, leerAjustesTareas, reprogramarAvisosTareas,
} from '../../utils/avisosTareas';
import { recordarAjusteDispositivo } from '../../utils/preferencias';
import { Campo, MensajeError, ModalBase, botonPrincipal, claseInput } from './ui';

/**
 * Avisos en este iPhone de las tareas que te tocan. Como pide Apple, el
 * permiso se pide al encenderlos, no al abrir la app.
 */
export const ModalAvisosTareas: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const { user } = useAuth();
  const { tareas, casas } = useTareas();
  const [ajustes, setAjustes] = useState<AjustesAvisosTareas | null>(null);
  const [error, setError] = useState('');
  const [guardando, setGuardando] = useState(false);

  useEffect(() => { leerAjustesTareas().then(setAjustes); }, []);

  const guardar = async () => {
    if (!ajustes) return;
    setGuardando(true);
    setError('');
    const ok = await guardarAjustesTareas(ajustes);
    if (!ok) {
      setError('El iPhone no deja enviar avisos a myarinn. Actívalos en Ajustes → myarinn → Notificaciones.');
      setGuardando(false);
      return;
    }
    recordarAjusteDispositivo({ avisosTareas: ajustes });
    await reprogramarAvisosTareas(tareas, casas, user?.uid).catch(() => {});
    onClose();
  };

  return (
    <ModalBase titulo="Avisos de tareas" onClose={onClose}>
      <div className="p-5 space-y-4">
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Te avisamos de las tareas que te tocan a ti, de las de «Mis tareas» y de las de «Cualquiera» de tus casas. Las que tienen hora, a esa hora; el
          resto, juntas por la mañana.
        </p>
        <MensajeError texto={error} />
        {ajustes && (
          <>
            <label className="flex items-center justify-between gap-3 cursor-pointer">
              <span className="text-sm font-semibold text-gray-900 dark:text-white">Avisarme en este iPhone</span>
              <input type="checkbox" checked={ajustes.activos} className="w-5 h-5 accent-lumbre-600"
                onChange={e => setAjustes({ ...ajustes, activos: e.target.checked })} />
            </label>
            {ajustes.activos && (
              <Campo label="Aviso de la mañana" ayuda="Para las tareas sin hora.">
                <input type="time" value={ajustes.horaResumen} className={claseInput}
                  onChange={e => setAjustes({ ...ajustes, horaResumen: e.target.value || '09:00' })} />
              </Campo>
            )}
            <button onClick={guardar} disabled={guardando} className={`w-full py-2.5 ${botonPrincipal}`}>
              {guardando ? 'Guardando…' : 'Guardar'}
            </button>
          </>
        )}
      </div>
    </ModalBase>
  );
};
